import { Dimensions, ImageStyle, StyleSheet, TextStyle, ViewStyle } from 'react-native';
import { isMobileDeviceValue, PCMaxWidth, PCMaxWidthNumber, PCMaxWidthRemValue } from './device-info';

const isNotUndefind = val => typeof val !== 'undefined';

export function padding(top, right?, bottom?, left?) {
    return {
        paddingTop: top,
        paddingRight: isNotUndefind(right) ? right : top,
        paddingBottom: isNotUndefind(bottom) ? bottom : top,
        paddingLeft: isNotUndefind(left) ? left : isNotUndefind(right) ? right : top,
    };
}

export function margin(top, right?, bottom?, left?) {
    return {
        marginTop: top,
        marginRight: isNotUndefind(right) ? right : top,
        marginBottom: isNotUndefind(bottom) ? bottom : top,
        marginLeft: isNotUndefind(left) ? left : isNotUndefind(right) ? right : top,
    };
}

export function borderRadius(top, right?, bottom?, left?) {
    return {
        borderTopLeftRadius: top,
        borderTopRightRadius: isNotUndefind(right) ? right : top,
        borderBottomRightRadius: isNotUndefind(bottom) ? bottom : top,
        borderBottomLeftRadius: isNotUndefind(left) ? left : isNotUndefind(right) ? right : top,
    };
}

/**
 * @deprecated 半屏拖全凭容器vh不对
 */
export function vh(percentage) {
    const viewportHeight = Dimensions.get('window').height;
    const decimal = percentage * 0.01;
    let _percentage = parseInt(percentage, 10);

    // Hard limits
    if (_percentage < 0) {
        _percentage = 100;
    }
    if (_percentage > 1000) {
        _percentage = 1000;
    }

    return Math.round(viewportHeight * decimal);
}

export function vw(percentage) {
    const viewportWidth = Dimensions.get('window').width;
    const decimal = percentage * 0.01;
    let _percentage = parseInt(percentage, 10);

    // Hard limits
    if (_percentage < 0) {
        _percentage = 100;
    }
    if (_percentage > 1000) {
        _percentage = 1000;
    }

    return Math.round(viewportWidth * decimal);
}

export function vwWithPC(percentage) {
    if (isMobileDeviceValue) {
        return vw(percentage);
    }
    return (PCMaxWidthRemValue * percentage) / 100 + 'rem';
}

const { width, height } = Dimensions.get('window');

/**
 * 宽度414px 设计稿下缩放
 */
const BaseW = 414;
/**
 * 宽度414px 设计稿下缩放
 * @param num 宽度值
 * @param shouldRound 是否需要取整，四舍五入
 */
export function scaleW(num: number | string, options?: { shouldRound?: boolean }) {
    let _num = num as number;
    if (typeof num === 'string') {
        _num = parseFloat(num);
    }
    return _num;
    // return options?.shouldRound ? Math.round((width * _num) / BaseW) : (width * _num) / BaseW;
}

/**
 * 高度 874px 设计稿下缩放
 */
const BaseH = 874;
export function scaleH(num: number) {
    return (height * num) / BaseH;
}

export function scaleHV2(num: number, BaseHV2?: number) {
    return (height * num) / (BaseHV2 ? BaseHV2 : BaseH);
}

const scaleProps = [
    'width',
    'height',
    'top',
    'bottom',
    'left',
    'right',
    'radius',
    'borderTopLeftRadius',
    'borderTopRightRadius',
    'borderBottomLeftRadius',
    'borderBottomRightRadius',
    'borderRadius',
    'borderWidth',
    'padding',
    'paddingLeft',
    'paddingRight',
    'paddingTop',
    'paddingBottom',
    'paddingHorizontal',
    'maxWidth',
    'minWidth',
    'maxHeight',
    'minHeight',
    'margin',
    'marginLeft',
    'marginRight',
    'marginTop',
    'marginBottom',
    'marginHorizontal',
    'marginVertical',
    'fontSize',
    'lineHeight',
];

export function styles<T extends Partial<ViewStyle | TextStyle | ImageStyle>>(
    styleRules: T,
    options = {
        // 是否自适应宽高
        scaleW: false,
    }
) {
    // 自动缩放宽高
    if (options.scaleW) {
        // 用到了，自己就往里面加，刚开始可能不全，慢慢完善
        scaleProps.forEach(prop => {
            if (typeof styleRules[prop] === 'number') {
                styleRules[prop] = scaleW(styleRules[prop]);
            }
        });
    }
    return styleRules as T;
}

export const styleGlobal = StyleSheet.create({"blackPrice":{"color":"#000"},"orangePrice":{"color":"#FF4906"},"primaryColor":{"color":"#FF4906"},"color999":{"color":"#999"}});

export function createStyleSheet<T extends StyleSheet.NamedStyles<T> | StyleSheet.NamedStyles<any>>(styles: T | StyleSheet.NamedStyles<T>): T {
    Object.keys(styles).forEach(key => {
        const style = styles[key];
        Object.keys(style).forEach(prop => {
            if (scaleProps.includes(prop)) {
                style[prop] = scaleW(style[prop]);
            }
        });
    });
    return styles as T;
}

/**
 * 将 px 值转换为 rem 值
 * @param {number|string} pxValue - 需要转换的 px 值
 * @param {number} baseFontSize - 基础字体大小
 * @returns {string} 转换后的 rem 值
 */
export function pxToRem(pxValue, baseFontSize = 414 / 100) {
    if (typeof pxValue !== 'number') {
        return pxValue;
    }

    // 进行 px 到 rem 的转换
    const pxNumber = parseFloat(pxValue);
    const remValue = pxNumber / baseFontSize;
    return `${remValue}rem`;
}

export function convertPxToRem(styleObj) {
    const newStyleObj = {};
    for (const key in styleObj) {
        if (scaleProps.includes(key)) {
            const pxValue = styleObj[key];
            newStyleObj[key] = pxToRem(pxValue);
        } else {
            newStyleObj[key] = styleObj[key];
        }
    }
    return newStyleObj;
}
